import * as K from './HotelsConstants';
import Fuse from 'fuse.js';
import feathers from '../../../feathers';
import floopback from '../../../lib/floopback';
var Hotels = new floopback('hotels');

export function find(params) {
  return async (dispatch, getState) => {
    const _this = this;
    const hotelsResults = await feathers.service('hotels').find({
      query: params,
    });
    dispatch({
      type: K.FIND + '_FULFILLED',
      payload: hotelsResults.data,
    });

    _this.searchTable(getState().Hotels.search);
  };
}

export function findById(id) {
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND_BY_ID,
      payload: Hotels.findById(id),
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      Hotels.create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      Hotels.update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function updateMultiple(ids, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: K.UPDATE_MULTIPLE + '_PENDING',
        payload: { ids, formData },
      });

      const updatePromises = ids.map((id) => Hotels.update(id, formData));

      Promise.all(updatePromises)
        .then(function (results) {
          dispatch({
            type: K.UPDATE_MULTIPLE + '_FULFILLED',
            payload: { results, ids },
          });
          resolve(results);
        })
        .catch(function (error) {
          dispatch({
            type: K.UPDATE_MULTIPLE + '_REJECTED',
            payload: { error, ids },
          });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      Hotels.delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['name', 'address', 'description'],
    };

    var fuse = new Fuse(getState().Hotels.data, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: {
        search: search,
        searchData: result,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Hotels/redux/HotelsActions.jsx